export default {
  setTicketsArray(state,t){
    state.ticketsArray = t;
  }
}